import { h } from 'preact'

const LockIcon = () => {
    return (
        <svg className='activity-row-button-lock' fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path stroke="#1D1D1D" stroke-width="2" stroke-linejoin="round" d="M5 8h14v13H5z"/>
            <path clip-rule="evenodd" d="M8 6a3 3 0 013-3h2a3 3 0 013 3v2H8V6z" stroke="#1D1D1D" stroke-width="2"/>
            <path d="M12 13v.02" stroke="#1D1D1D" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 14.5v3" stroke="#1D1D1D" stroke-linecap="square"/>
        </svg>
    )
}

export default LockIcon